module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Thin.68c704cd.woff";